export default function UpdateContactDialogError({
  contactId,
}: {
  contactId: string | null;
}) {
  //TODO: Enrich the UI for this component (could happen when either server's down, or
  //contact is deleted but the user stills maintains the stale data from that contact
  return (
    <div>
      <p>An error occurred while updating contact with ID {contactId}.</p>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        Go back
      </button>
    </div>
  );
}
